import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { useSelector } from "react-redux";
import navigationConfig from "configs/NavigationConfig";

const getFirstAllowedRoute = (menus, permissions = []) => {
  for (const menu of menus) {
    if (menu.submenu?.length) {
      const found = getFirstAllowedRoute(menu.submenu, permissions);
      if (found) return found;
    }
    if (menu.isGroupTitle) continue;
    if (!menu.permission || permissions.includes(menu.permission)) {
      if (menu.path) return menu.path;
    }
  }
  return null;
};

const DefaultRedirect = () => {
  const { permissionCodes } = useSelector((state) => state.auth);

  if (!permissionCodes?.length) {
    return null;
  }

  const firstAllowedPath = getFirstAllowedRoute(navigationConfig, permissionCodes);

  if (!firstAllowedPath) {
    return <div>Bạn không có quyền truy cập</div>;
  }

  return <Navigate replace to={firstAllowedPath} />;
};

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<DefaultRedirect />} />
        {protectedRoutes.map((route, index) => (
          <Route
            key={route.key + index}
            path={route.path}
            element={
              <AppRoute
                routeKey={route.key}
                title={route.title}
                component={route.component}
                {...route.meta}
              />
            }
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <AppRoute
                routeKey={route.key}
                title={route.title}
                component={route.component}
                {...route.meta}
              />
            }
          />
        ))}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;